import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { openPDFtab } from "../utils/openPDFTab";
import { getTenantSettings } from "../APIs/TenantSettingsAPI";

export default function FatturazioneRiepilogo({ open, onClose, invoice }) {
    const { t } = useTranslation();
    const theme = useTheme();

    const [tenantSettings, setTenantSettings] = useState(null);

    useEffect(() => {
        const loadSettings = async () => {
            const token = localStorage.getItem("accessToken");
            const tenant = localStorage.getItem("tenantId");

            const settings = await getTenantSettings(token, tenant);
            setTenantSettings(settings);
        };

        loadSettings();
    }, []);

    const filename = tenantSettings
        ? `${tenantSettings.vatNumber}_${invoice?.id}`
        : "";

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <Stack spacing={2}>
                    <Box textAlign="right">
                        <Button variant="text"
                            onClick={() => onClose()}
                            sx={theme.checkout.closeModalCheckout_button}
                        >{t("tableMapPage.close")}</Button>
                    </Box>
                    <Typography variant="h5" textAlign={"center"}>
                        {t("billing.summary.title")}
                    </Typography>
                    <Typography variant="body1" textAlign={"center"}>
                        {t("billing.summary.subtitle")}
                    </Typography>
                    <Box minHeight={"1px"}>
                        <Box sx={{ py: "24px" }} ><Divider /></Box>
                        <Box>
                            <Box textAlign={"center"}>
                                <Typography variant="h5" display={"inline-flex"} alignItems={"center"} gap={1}>
                                    {t("billing.summary.fileName")}:
                                </Typography>
                            </Box>
                            <Box textAlign={"center"} mb={1}>
                                <Typography variant="body1" display={"inline-flex"} alignItems={"center"} gap={1}>
                                    {filename}.xml
                                </Typography>
                            </Box>
                        </Box>
                        <Stack direction={"row"} spacing={2} justifyContent={"center"} mt={2}>
                            <IconButton variant='outlined' onClick={() => openPDFtab(invoice?.id)}>
                                <VisibilityIcon />
                                <Typography> {t("billing.actions.view")}</Typography>
                            </IconButton>
                        </Stack>
                    </Box >
                </Stack>
            </DialogContent>
        </Dialog>
    )
}